import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './button';

export interface PaginationBarProps {
  page: number;
  totalPages: number;
  total?: number;
  onPageChange: (page: number) => void;
}

/** List footer: "{total} total · Page X of Y" and Prev/Next. The one `DataTable` renders. */
export function PaginationBar({ page, totalPages, total, onPageChange }: PaginationBarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-t border-border/60 px-4 py-3 text-sm">
      <span className="text-muted-foreground">
        {total != null ? `${total} total · Page ${page} of ${totalPages}` : `Page ${page} of ${totalPages}`}
      </span>
      {totalPages > 1 && (
        // `size="icon"` rather than `size="sm"` + an h/w override: the sm size
        // carries a `sm:h-9`, and an unprefixed `h-10` does not merge away a
        // breakpoint-prefixed height, so the override left these 40x36.
        <div className="flex items-center gap-1.5">
          <Button
            variant="outline"
            size="icon"
            aria-label="Previous page"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            <ChevronLeft className="h-4 w-4 shrink-0" />
          </Button>
          <Button
            variant="outline"
            size="icon"
            aria-label="Next page"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            <ChevronRight className="h-4 w-4 shrink-0" />
          </Button>
        </div>
      )}
    </div>
  );
}
